import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, SxProps } from '@modusign/design-system';

interface DropdownIconProps extends SxProps {
  icon: IconProp;
}

function DropdownIcon({ icon, sx }: DropdownIconProps) {
  return (
    <Flex
      alignItems="center"
      color="iconPrimaryBase"
      height="18px"
      justifyContent="center"
      sx={sx}
      width="18px"
    >
      <FontAwesomeIcon icon={icon} />
    </Flex>
  );
}

export default DropdownIcon;
